export default __webpack_public_path__ + "8b1669ed6ce3582685ae22d5d0385f73.png";